import React from "react";

//#region Types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
//#region Components
import TopTodoCard from "components/todos/_partials/topTodoCard";
import { TitledContainerInner, EntityCardContent } from "components/common";
import AnnualReportSigningStepsFooter from "components/annualAccount/annualReportSigningSteps/footer";
import AnnualReportTimeline from "components/annualAccount/annualReportSigningSteps/annualReportTimeline";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import { Description } from "components/common/wintForms";

const AnnualReportSigningStepsTodo: React.FC<TodoCardProps> = (props) => {
  const { item } = props;
  const annualReportSigningSteps = item.annualReportSigningSteps;
  const annualReportState =
    annualReportSigningSteps?.state ?? WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.NotStarted; //The current state of the annual report

  const getAnnualReportStateTranslations = (state: WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState) => {
    const steps = [
      {
        state: WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.AnnualReportSigningStarted,
        title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Todos.TodoCardName_AnnualReportDocument),
        subHeaderText: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.AnnualAccount.AnnualReportSigningStepsSubHeaderFirstState
        ),
      },
      {
        state: WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.GeneralMeetingSigningStarted,
        title: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Todos.TodoCardName_GeneralMeetingDocument
        ),
        subHeaderText: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.AnnualAccount.AnnualReportSigningStepsSubHeaderSecondState
        ),
      },
      {
        state: WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.XbrlFileSubmitted,
        title: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Todos.TodoCardName_BolagsverketSubmission
        ),
        subHeaderText: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.AnnualAccount.AnnualReportSigningStepsSubHeaderThirdState
        ),
      },
    ];

    const stepDetails = steps.find((step) => step.state === state);

    //fallback case
    return (
      stepDetails ?? {
        state: 0,
        title: "",
        subHeaderText: "",
      }
    );
  };

  const { title, subHeaderText } = getAnnualReportStateTranslations(annualReportState);

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={{
            ...props.item,
          }}
          overrideTitle={title}
          footerText={`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Due_Date
          )}: ${LocalizationHelperInstance.getFormattedDate(DateHelper.addDays(props.item.date, 5))}`}
          descriptionHeadingTwo={annualReportSigningSteps?.companyName}
        />
      }
      todoMainSection={
        <>
          <TitledContainerInner
            header={LocalizationHelperInstance.getFormattedMessage(
              annualReportState === WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.XbrlFileSubmitted
                ? TranslationKeys.AnnualAccount.AnnualReportSigningStepsHeaderXbrlSubmitted
                : TranslationKeys.AnnualAccount.AnnualReportSigningStepsAtOneFlowHeader
            )}
            subHeader={LocalizationHelperInstance.getFormattedMessage(subHeaderText)}
          >
            <AnnualReportTimeline annualReportState={annualReportState} signers={annualReportSigningSteps?.signers} />
            {annualReportState === WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.XbrlFileSubmitted && (
              <Description horizontal>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.AnnualAccount.AnnualReportSigningStepsBolagsverketDescription
                )}
              </Description>
            )}
          </TitledContainerInner>
        </>
      }
      footer={
        <AnnualReportSigningStepsFooter
          annualAccountReport={annualReportSigningSteps!}
          markAsDoneHandler={props.onActionSuccess}
        />
      }
    ></EntityCardContent>
  );
};

export default AnnualReportSigningStepsTodo;
